import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent, RCSData, RCSMessageTypeEnum, UtilHelper } from 'lib-trend-core';

/**
 * Phone-bubble preview of one RCS message — the six formats of the RCS editor. Shared by the
 * campaign wizard and the webhook integration (SPEC-2026-10-rcs-webhook-integration-messages);
 * formerly `campaign-rcs-template`. A carousel shows its first card.
 */
@Component({
    selector: 'rcs-message-preview',
    templateUrl: './rcs-message-preview.component.html',
    styleUrls: ['./rcs-message-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RcsMessagePreviewComponent extends AbstractComponent implements OnInit, OnChanges {
  avatarUrl: string = 'https://firebasestorage.googleapis.com/v0/b/infinite7-70f9d.appspot.com/o/blank.png?alt=media&token=fea2ea97-edbd-4589-a52e-e4b8d786be0b';

  @Input('rcsData') rcsData: RCSData;

  title: string;
  inputText: string;
  type: string;
  fileUrl: string;
  buttons: any;
  dateHeader: string;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.dateHeader = new Date().toLocaleString('pt-BR', {
      weekday: 'long',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    }).replace('.', '');
    this.updateTemplateParams();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['rcsData']?.currentValue) {
      this.updateTemplateParams();
    }
  }

  updateTemplateParams(): void {
    if (!this.rcsData) return;
    if (this.rcsData.type === RCSMessageTypeEnum.RICH_CARD && this.rcsData.richCard) {
      this.title = this.rcsData.richCard.title || '';
      this.inputText = this.rcsData.richCard.description || '';
      this.type = this.rcsData.richCard.fileContentType || '';
      this.fileUrl = this.rcsData.richCard.fileUrl || '';
      this.buttons = this.rcsData.richCard.suggestions || [];
    } else if (this.rcsData.type === RCSMessageTypeEnum.CAROUSEL && this.rcsData.carousel && Array.isArray(this.rcsData.carousel) && this.rcsData.carousel.length > 0) {
      const card = this.rcsData.carousel[0];
      this.title = card.title || '';
      this.inputText = card.description || '';
      this.type = card.fileContentType || '';
      this.fileUrl = card.fileUrl || '';
      this.buttons = card.suggestions || [];
    } else {
      this.title = '';
      this.inputText = this.rcsData.message || '';
      this.type = this.rcsData.type || '';
      this.fileUrl = this.rcsData.url || '';
      this.buttons = [];
    }
  }

  formatWhatsappMessage(text: string): string {
    if (text) {
      return UtilHelper.formatWhatsappMessage(text);
    } else {
      return '';
    }
  }

  getType() {
    const mimeType = this.type || '';
    return mimeType.split('/')[0];
  }
}
